module.exports = __webpack_public_path__ + "img/nyyjs-4.3455ba73.jpg";